import { render } from "./footer-section.vue?vue&type=template&id=3815c43c"
import script from "./footer-section.vue?vue&type=script&lang=js"
export * from "./footer-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__